import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import AppButton from '../../../components/designe/app-button/AppButton';
import ConfirmDialog from '../../../components/reusable/confirm-dialog/ConfirmDialog';
import { useStyles } from './ExerciseOptions.styles';
import theme from '../../../styles/theme';
import { useAccess } from '../../../hooks/useAccess';
import { useExerciseOptionComponent } from './useExerciseOptionComponent';
import Search from '../../../components/reusable/search/Search';
import FlexibleColumnsTable from '../../../components/reusable/Table/FlexibleColumnsTable';
import AppDialog from '../../../components/reusable/app-dialog/AppDialog';
import AddExerciseOption from './add-exercise-option/AddExerciseOption';
import { ExerciseOptionsFilter } from './ExerciseOptionsFilter';

function ExerciseOptions() {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    sortedArray,
    columnsList,
    order,
    orderBy,
    cellReducers,
    onSort,
    onSortColumns,
    itemForDelete,
    setItemForDelete,
    onItemDelete,
    filter,
    setFilter,
    showEditModal,
    setShowEditModal,
    itemForEditing,
    setItemForEditing,
    filterFormik,
    filterTypeOptions,
    filterDefaultOptions,
    filterActiveOptions,
  } = useExerciseOptionComponent(classes);
  const { access } = useAccess();

  return (
    <div className={classes.wrapper}>
      <ExerciseOptionsFilter
        formik={filterFormik}
        filterTypeOptions={filterTypeOptions}
        filterDefaultOptions={filterDefaultOptions}
        filterActiveOptions={filterActiveOptions}
      />
      <Box display="flex" gap={1} alignItems="center" marginBottom={2}>
        <Search fullWidth value={filter} onChange={setFilter} />
        {access?.exerciseOptions?.canCreate && (
          <AppButton onClick={() => setShowEditModal(true)}>
            {t('common.add')}
          </AppButton>
        )}
      </Box>
      <FlexibleColumnsTable
        data={sortedArray}
        columnsList={columnsList}
        order={order}
        orderBy={orderBy}
        onSort={onSort}
        classes={classes}
        onSortColumns={onSortColumns}
        cellReducers={cellReducers}
        onSelectAllRows={() => {}}
        stickyHeader={true}
      />
      <ConfirmDialog
        open={!!itemForDelete}
        onClose={() => setItemForDelete(null)}
        title={t('common.delete')}
        onSubmit={() => onItemDelete()}>
        {t('common.deleteQuestion')}
      </ConfirmDialog>

      <AppDialog
        open={!!showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setItemForEditing(null);
        }}
        title={
          itemForEditing
            ? t('adminDashboard.editExerciseOption')
            : t('adminDashboard.addExerciseOption')
        }>
        <AddExerciseOption
          exerciseOption={itemForEditing}
          onClose={() => {
            setShowEditModal(false);
            setItemForEditing(null);
          }}
        />
      </AppDialog>
    </div>
  );
}

export default ExerciseOptions;
